module.exports = __webpack_public_path__ + "img/line-refund.a6e4da39.png";